import { forwardRef } from "react"
import { DatePicker as GoDesignDatePicker } from "@gogoro/go-design"

import { DatePickerProps } from "./DatePickerProps"

import styles from "./styles.module.scss"

export const defaultFormatInput = (value: unknown | null) => {
  return value ? new Date((value as number) * 1000) : null
}

export const defaultFormatOutput = (value: Date) => {
  if (isNaN(value?.getTime())) {
    return null
  }

  const timeStamp = Math.floor(value.getTime() / 1000)
  return timeStamp
}

const DatePicker = (
  {
    value,
    name,
    onChange,
    placeholder,
    formatInput = defaultFormatInput,
    formatOutput = defaultFormatOutput,
    ...restProps
  }: DatePickerProps,
  ref: React.Ref<HTMLInputElement>,
) => {
  const handleOnChange = (value: any) => {
    const currentTime = formatOutput(value)
    if (onChange) {
      onChange(currentTime)
    }
  }

  const selectedDate = value ? formatInput(value) : null

  const finalProps = {
    name,
    placeholderText: placeholder,
    dateFormat: "yyyy/MM/dd",
    isClearable: true,
    onChange: handleOnChange,
    selected: selectedDate,
    ref,
    ...restProps,
  }

  return (
    <div className={styles["container"]} data-testid={`date-picker-${name}`}>
      <GoDesignDatePicker {...finalProps} />
    </div>
  )
}

export default forwardRef(DatePicker)
